import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import MaintenanceBanner from "./MaintenanceBanner";
import { initAnalytics, trackPageView } from "../lib/analytics";
import { BookingModalProvider } from "../context/BookingModalContext";

/**
 * Shared site chrome: Navbar + routed page + Footer + floating WhatsApp
 * button. Also handles scroll-to-top and GA4 page-view tracking on every
 * route change.
 */
const Layout: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname);
  }, [pathname]);

  return (
    <BookingModalProvider>
      <div className="flex flex-col min-h-screen">
        <MaintenanceBanner />
        <Navbar />
        <main className="flex-grow">
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
      </div>
    </BookingModalProvider>
  );
};

export default Layout;
